import moment from "moment"
import { getCompaniesValuesByOptions, getDatasPeloPeriodo } from "../../helpers/utils"

/*
 * Parâmetros do relatório de Movimento de vendas, para o PDF e para o CSV.
 *
 * O intervalo sai de getDatasPeloPeriodo — o mesmo helper que o grid usa — para o
 * relatório não responder sobre um período diferente do que a tela está mostrando.
 */
export const montarParametrosRelatorio = (filtros, tipoRelatorio, agruparPorStatus) => {
  const intervalo = getDatasPeloPeriodo(filtros.period, filtros.startDate, filtros.endDate, false)
  const hoje = moment()

  return {
    company: getCompaniesValuesByOptions(filtros.companies),
    status: filtros.situacao,
    tipo: filtros.tipoAtendimento,
    atendimento: filtros.atendimento,
    caixa: filtros.fitaCaixa,
    mesa: filtros.mesa,
    funcionarioCaixa: filtros.usuarioCaixa,
    funcionarioVenda: filtros.usuarioVenda,
    funcionarioEntregador: filtros.usuarioEntregador,
    agrupaStatus: agruparPorStatus === undefined ? false : agruparPorStatus,
    tipoRelatorio,
    dataInicial: (intervalo ? intervalo.inicio : hoje).format("YYYY-MM-DD"),
    dataFinal: (intervalo ? intervalo.fim : hoje).format("YYYY-MM-DD")
  }
}

/*
 * Exportação "Vendas com itens" (IW-349): dois CSVs pedidos separadamente — "itens"
 * (um lançamento por linha) e "vendas" (uma venda por linha) — com os mesmos filtros e o
 * mesmo período do relatório, que também vão no nome do arquivo.
 */
export const montarExportacaoVendasComItens = (filtros, conteudo) => {
  const params = { ...montarParametrosRelatorio(filtros, "V", false), exportacao: conteudo }
  const prefixo = conteudo === "itens" ? "vendas_itens" : "vendas"

  return { name: `${prefixo}_${params.dataInicial}_a_${params.dataFinal}`, params }
}
